// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WRIT","col":"styles_col__5vrGe"};